import AppContext from "PFApp/app_context";
import PropTypes from "prop-types";
import React, { useContext } from "react";

import RolesRows from "./roles_rows";

const RolesRowsConnected = ({ items, isLoading }) => {
  const {
    store: {
      pages: {
        workflowPage: {
          roles: {
            columns,
            fetchData,
            pinnedIds,
            setPinnedIds,
            selectedIds,
            setSelectedIds,
            unseen: { markAsRead },
            modals: { share: shareModal, addCoOwner: addCoOwnerModal }
          }
        }
      }
    }
  } = useContext(AppContext);

  const handleShareRole = (rowId) => {
    setSelectedIds([rowId]);
    shareModal.setVisibility(true);
  };

  const handleAddCoOwner = (rowId) => {
    setSelectedIds([rowId]);
    addCoOwnerModal.setVisibility(true);
  };

  return (
    <RolesRows
      items={items}
      isLoading={isLoading}
      columns={columns}
      pinnedIds={pinnedIds}
      setPinnedIds={setPinnedIds}
      selectedIds={selectedIds}
      setSelectedIds={setSelectedIds}
      markAsRead={markAsRead}
      utmSource="workflow"
      roleKey="role"
      onRoleDeleted={fetchData}
      onRoleShare={handleShareRole}
      onAddCoOwner={handleAddCoOwner}
    />
  );
};

RolesRowsConnected.propTypes = {
  items: PropTypes.array.isRequired,
  isLoading: PropTypes.bool
};

export default RolesRowsConnected;
